// Angular
import { Component, Input } from "@angular/core";

// Antd
import { NzIconModule } from "ng-zorro-antd/icon";

@Component({
    selector: "app-loader",
    imports: [NzIconModule],
    templateUrl: "./loader.component.html",
    styleUrl: "./loader.component.scss",
})
export class LoaderComponent {
    @Input() contentLoader = false;
    @Input() guestLoader = false;
}
